import { render, staticRenderFns } from "./CertificadoDptovPage.vue?vue&type=template&id=827dd1fa"
import script from "./CertificadoDptovPage.js?vue&type=script&lang=js&external"
export * from "./CertificadoDptovPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports